import FaqBlock from './FaqBlock'

export default FaqBlock
